import { useMemo } from "react"
import z from "zod"

import {
  DateFilterOperator,
  DateFilterType,
} from "@tfg/types/types/date-filter.dto"

export type OperatorSelectItem = {
  label: string
  value: DateFilterOperator
  key: DateFilterOperator
}

export const useGetOperatorsForDateFilterType = (
  type: DateFilterType
): DateFilterOperator[] => {
  const operators = useMemo((): DateFilterOperator[] => {
    const allOperators: DateFilterOperator[] = z
      .array(z.enum(DateFilterOperator))
      .parse(Object.values(DateFilterOperator))

    if (type === DateFilterType.FIXED) {
      return allOperators
    }

    return allOperators.filter(
      (operator) =>
        ![
          DateFilterOperator.BETWEEN,
          DateFilterOperator.IS_NOT_BETWEEN,
        ].includes(operator)
    )
  }, [type])

  return operators
}

export const useOperatorsSelectItems = (
  labelTranslationResolver: Record<DateFilterOperator, string>,
  type: DateFilterType
): OperatorSelectItem[] => {
  const operators = useGetOperatorsForDateFilterType(type)

  return useMemo(() => {
    return operators.map(
      (operator: DateFilterOperator): OperatorSelectItem => ({
        label: labelTranslationResolver[operator] ?? "",
        value: operator,
        key: operator,
      })
    )
  }, [labelTranslationResolver, operators])
}
